import * as Sentry from '@sentry/react'
import type { CaptureContext } from '@sentry/core'
import { __DEV__, APP_ENV, SENTRY_DSN } from '@/constants'

Sentry.init({
  dsn: SENTRY_DSN,
  environment: APP_ENV,
  enabled: !__DEV__,
  sendDefaultPii: false
})

// export const recordMessage = (
//   message: string,
//   level: Sentry.Event['level'],
//   extra: Record<string, unknown> = {}
// ) => {
//   if (__DEV__) console.info('Record Message', message, level)
//   else Sentry.captureMessage(`${level}: ${message}`, { extra })
// }

export const recordException = (
  error: Error,
  extra?: CaptureContext
) => {
  // eslint-disable-next-line no-console
  if (__DEV__) console.error('Record Exception', error, extra)
  else Sentry.captureException(error, extra)
}

// Sentry test function globally accessible
window.sentryTest = () => {
  recordException(
    new Error('Sentry test: this is a test error for Sentry reporting'),
    { extra: { test: true } }
  )
}

export const setUser = Sentry.setUser
export const clearUser = () => Sentry.setUser(null)
